import redirect from './redirect';
import { setCookie, getCookie, removeCookie } from './session';
import { authenticate } from '../services/authApi';
import { createUser } from '../services/userApi';

export const signIn = async (email, password) => {
	const res = await authenticate(email, password);
	if (!res.user) {
		return res;
	}
	setCookie("jwt", res.user.token);
	redirect("/home");
	return null;
}

export const signUp = async (name, email, password, password_confirmation, affiliate, ref, banner) => {
	const res = await createUser(name, email, password, password_confirmation, affiliate, ref, banner);
	console.log(res);
	if (!res.user) {
		return res;
	}
	setCookie("jwt", res.user.token);
	redirect("/subscribe");
	return null;
};

export const signOut = (ctx = {}) => {
	if (process.browser) {
		removeCookie("jwt");
		localStorage.removeItem('token');
		redirect("/signin", ctx);
	}
};

export const getJwt = ctx => {
	return getCookie("jwt", ctx.req);
};

export const isAuthenticated = ctx => !!getJwt(ctx);

export const redirectIfAuthenticated = ctx => {
	if (isAuthenticated(ctx)) {
		redirect("/home", ctx);
		return true;
	}
	return false;
};

export const redirectIfNotAuthenticated = ctx => {
	if (!isAuthenticated(ctx)) {
		redirect("/signin", ctx);
		return true;
	}
	return false;
};

export const redirectIfNotSubscribed = (ctx, user) => {
	if(!user.subscribed) {
		redirect("/subscribe", ctx);
		return true;
	}
	return false;
}

export const redirectIfSubscribed = (ctx, user) => {
	if(user.subscribed) {
		redirect("/home", ctx);
		return true;
	}
	return false;
}

export const redirectIfNotExist = (ctx) => {
	
}


// WEBPACK FOOTER //
// ./src/lib/auth.js